import { render } from "./PendingDsos.vue?vue&type=template&id=2b5900b7&scoped=true"
import script from "./PendingDsos.vue?vue&type=script&lang=js"
export * from "./PendingDsos.vue?vue&type=script&lang=js"

import "./PendingDsos.vue?vue&type=style&index=0&id=2b5900b7&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5900b7"]])

export default __exports__